export default {
    INTERNAL_SERVER_ERROR: -999,
    UNAUTHORIZED: -1,
    FORBIDDEN: -2,
    INVALID_PARAMS: -3,
    USERNAME_OR_PASSWORD_INCORRECT: -20,
    ACCOUNT_STATUS_ABNORMAL: -21,
}